import {
  SET_SUB_MENU_ITEMS,
  SET_SUB_MENU_COLLAPSED,
  SET_SUB_MENU_ROUTE,
  SET_ASSET_SUBMENU_ITEMS,
  SET_ASSET_SUBMENU,
} from '../../mutations';

export default {
  [SET_SUB_MENU_ITEMS](store, items) {
    store.subMenu.items = items;
  },
  [SET_SUB_MENU_COLLAPSED](store, state) {
    store.subMenu.collapsed = state;
  },
  [SET_SUB_MENU_ROUTE](store, state) {
    store.subMenu.previousRouteName = store.subMenu.routeName;
    store.subMenu.routeName = state;
  },
  [SET_ASSET_SUBMENU_ITEMS](store, items) {
    store.assetSubMenu.items = items;
  },
  [SET_ASSET_SUBMENU](store, submenu) {
    store.assetSubMenu = submenu;
  },
};
